// extracted by mini-css-extract-plugin
export default {"root":"desktopMaxWidthContainer_root__P52sV","noPadding":"desktopMaxWidthContainer_noPadding__mnz+G"};